<template>
  <div class="animated fadeIn">
    <b-card>
        <div slot="header">Inventory Receipt Form 
            <div class="card-header-actions">
            <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
            </button>
            <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
            </div>
        </div>
        <b-row>
            <b-col lg="6">
                <b-row>
                    <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.recivDate" type="date" :disabled="((frmdata.rcpLineKey||'')!='')"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Number</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.purcRcpHdNo" ></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-input-group>
                    <b-input-group-prepend><label>Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.vendorinfo" style="width:40% !important;"></b-form-input>
                    <b-input-group-prepend><span class="pt-2">Delivery No.</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.vndShipNo"></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label >Purchase Order No.</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.purcOrderNo" style="width:40% !important;"></b-form-input>
                    <b-form-checkbox  class="ml-2 mt-2" v-model="frmdata.barangbarter" value=1 unchecked-value=0 style="font-weight:bolder;">P.O Barter</b-form-checkbox>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Quantity Purchase</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.QtyPO" readonly></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">{{frmdata.unitsize}}</span></b-input-group-prepend>
                    <b-input-group-prepend><span class="ml-3 pt-2">Value</span></b-input-group-prepend>
                    <b-input-group-prepend class="ml-2"><span class="input-group-text">{{frmdata.matauang}}</span></b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nilainett" :precision="2" readonly></my-number>
                </b-input-group>
            </b-col>
            <b-col lg="6"> 
                <v-dim :model="frmdata" :key="updateDim"></v-dim>
            </b-col>
        </b-row>
        <hr>
        <b-row h-align="center">
            <b-col lg="6" xl="6">
                <b-form-row>
                <b-col lg="7">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.partnumber"></b-form-input>
                    </b-input-group>
                </b-col>
                </b-form-row >                      
                <b-input-group>
                    <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.itemname"></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.typeseries"></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.description"></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Unit Price P.O.</label></b-input-group-prepend>
                    <b-input-group-prepend>
                    <span class="input-group-text">{{frmdata.matauang}}</span>
                    </b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nettpriceFCY" :precision="2" readonly></my-number>
                    <b-input-group-prepend class="ml-2">
                    <span class="input-group-text">{{uanguser}}</span>
                    </b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nettprice" :precision="2" readonly></my-number>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="7">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Inventory Group</label></b-input-group-prepend>
                            <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" :state="!$v.frmdata.inven_catid.$error" class="mr-2"></b-form-select>
                        </b-input-group>
                  </b-col>
                  <b-col lg="5">
                      <b-input-group>
                          <b-input-group-prepend><label class="text-right" style="width:155px;">Usage Status/Condition</label></b-input-group-prepend>
                        <b-form-select v-model="itemCondition" :options="conditionOpt" :plain="true"></b-form-select>
                      </b-input-group>
                  </b-col>
                </b-row >                      

                <!-- <b-input-group>
                    <b-input-group-prepend><label>item Status</label></b-input-group-prepend>
                    <b-form-select v-model="itemCondition" :options="conditionOpt" :plain="true"></b-form-select>
                    <b-form-checkbox  class="ml-1 mt-2" v-model="frmdata.barangbarter" value=1 unchecked-value=0 style="font-weight:bolder;">BARTER ITEM</b-form-checkbox>
                </b-input-group> -->

            </b-col>
            <b-col lg="6">
              <b-row>
                <b-col lg="7"> 
                  <b-input-group>
                      <b-input-group-prepend><label>Qty. PO Processed</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.qtyPurcRcp" type="number" :state="!$v.frmdata.qtyPurcRcp.$error" disabled :min="1" max="frmdata.QtyPO"></b-form-input>
                      <b-form-input readonly v-model="frmdata.unitsize" class="ml-1"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row >     
              <b-row>
                <b-col lg="7"> 
                  <b-input-group>
                      <b-input-group-prepend><label>Qty Inventory Split</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1" :disabled="(frmdata.quantity != frmdata.qtyAvail)"></b-form-input>
                      <b-form-input v-model="frmdata.invunitom" :state="!$v.frmdata.invunitom.$error" class="ml-1"></b-form-input>
                  </b-input-group>
                </b-col>                  
                <b-col lg="5"> 
                    <span class="mt-2">Pemecahan terkecil</span>
                </b-col>                  
              </b-row >     
              <b-input-group>
                  <b-input-group-prepend><label>Inventory Unit Price</label></b-input-group-prepend>
                  <b-input-group-prepend>
                  <span class="input-group-text">{{uanguser}}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right" v-model="frmdata.invUnitCost" :state="!$v.frmdata.invUnitCost.$error" :precision="2" :disabled="((frmdata.rcpLineKey||'')!='')"></my-number>
                    <b-form-checkbox  class="ml-2 mt-2" v-model="frmdata.qtyUndefined" value=1 unchecked-value=0>Inventory Value Balance (Quantity UnDefined)</b-form-checkbox>
              </b-input-group>
              <b-row>
                  <b-col lg="7">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Store/Warehouse </label></b-input-group-prepend>
                          <b-form-select v-model="frmdata.idStore" :plain="true" :options="warehouse" :state="!$v.frmdata.idStore.$error"></b-form-select>
                      </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                      <b-input-group>
                          <b-input-group-prepend><label style="width:113px !important; text-align:right;">Rack/Shelf No.</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.shelfNo" :state="!$v.frmdata.shelfNo.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
              <b-row>
                  <b-col lg="7">                            
                      <b-input-group v-if="frmdata.isexpireable">
                          <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.expirDate" type="date" :state="!$v.frmdata.expirDate.$error"></b-form-input>
                      </b-input-group>
                      <b-input-group v-if="frmdata.ishasserialno">
                          <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.serialNum" :state="!$v.frmdata.serialNum.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                      <b-input-group v-if="((frmdata.itemUsageType=='FIXED ASSET') && ((frmdata.barangbekas==1) || (frmdata.barangrusak==1)))">
                    <b-input-group-prepend><label class="text-right">No. Fixed Asset</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.fixAsetid" readonly></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
          </b-col>
        </b-row>
        <hr>
      <b-form-checkbox  class="mt-2" v-model="frmdata.gcif" value=1 unchecked-value=0>Use GCIF(Goods Confirmity Inspection Form)</b-form-checkbox>
        <b-button block variant="info" :disabled="(frmdata.gcif==0)" @click.stop="showGCIF=!showGCIF">GOODS CONFORMITY INSPECTION FORM</b-button>
            <b-card no-body v-if="showGCIF">
                <h6 class="ml-2 mt-3"> 1. PACKAGING & HANDLING CHECK</h6>
                <b-card-group>
                    <b-card>
                    <h6>A.TYPE</h6>
                    <b-form-radio-group stacked v-model="frmGCIFdata.typePack" name="packingType">
                        <b-form-radio value="Reusable Container">Reusable Container</b-form-radio>
                        <b-form-radio value="Wooden Box">Wooden Box</b-form-radio>
                        <b-form-radio value="Cartoon">Cartoon</b-form-radio>
                        <b-form-radio value="Unpacked">Unpacked</b-form-radio>
                    </b-form-radio-group>

                    </b-card>
                    <b-card>
                    <h6>B.CONDITION</h6>
                    <b-form-radio-group stacked v-model="frmGCIFdata.satisCondPack" name="packingCondition">
                        <b-form-radio :value="1">Satisfactory</b-form-radio>
                        <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                    </b-form-radio-group>
                    <b-form-group :horizontal="false" label="If Unsatisfactory explain :">
                        <b-form-textarea v-model="frmGCIFdata.unsatisConPackReason" rows="3" max-rows="6"></b-form-textarea>                    
                    </b-form-group>       
                    </b-card>
                </b-card-group>
                <h6 class="ml-2 mt-3">2. PRESERVATION CHECK</h6>
                <b-card>
                <b-row>
                    <b-col>
                    <b-form-radio-group stacked v-model="frmGCIFdata.satisPreserve" name="preservationCheck">
                        <b-form-radio :value="1">Satisfactory</b-form-radio>
                        <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                    </b-form-radio-group>
                    </b-col>
                    <b-col>
                    <b-form-group :horizontal="false" label="If Unsatisfactory explain :">
                        <b-form-textarea v-model="frmGCIFdata.unsatisPreserveReason" rows="2" max-rows="4" placeholder="Explaination Unsatisfactory Preservation Check"></b-form-textarea>                    
                    </b-form-group>
                    </b-col>
                </b-row>
                </b-card>
                <h6 class="ml-2">3. DOCUMENT CHECK</h6>
                <b-card-group>
                    <b-card>
                    <h6>A. GENERAL DOCUMENT</h6>
                        <b-form-checkbox v-model="frmGCIFdata.inventoryGenDocument"  key="inventoryGenDocument" >Item/Inventory List</b-form-checkbox> <br>
                        <b-form-checkbox v-model="frmGCIFdata.tagGenDoc"  key="tagGenDoc" >Tag & Log Book</b-form-checkbox> <br>
                        <b-form-checkbox v-model="frmGCIFdata.shipGenDoc"  key="shipGenDoc" >Shipping Document</b-form-checkbox> <br>
                    </b-card>
                    <b-card>
                    <h6>B. TECHNICAL DOCUMENT</h6>
                    <b-form-radio-group stacked v-model="frmGCIFdata.satisTechDoc" name="technicaldoc">
                        <b-form-radio :value="1">Satisfactory</b-form-radio>
                        <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                    </b-form-radio-group>
                    <b-form-group :horizontal="false" label="If Unsatisfactory explain :">
                        <b-form-textarea v-model="frmGCIFdata.unsatisTechDocReason" rows="3" max-rows="6"></b-form-textarea>                    
                    </b-form-group>       
                    </b-card>
                </b-card-group>
                <h6 class="ml-2 mt-3">4. MATERIAL CHECK</h6>
                <b-card-group>
                    <b-card>
                    <h6>A. CONDITION</h6>
                    <b-form-radio-group stacked v-model="frmGCIFdata.satisCondMaterial" name="materialCondition">
                        <b-form-radio :value="1">Satisfactory</b-form-radio>
                        <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                    </b-form-radio-group>
                    <b-form-group :horizontal="false" label="If Unsatisfactory explain :">
                        <b-form-textarea v-model="frmGCIFdata.unSatisCondMaterialReason" rows="3" max-rows="6"></b-form-textarea>                    
                    </b-form-group>       
                    </b-card>
                    <b-card>
                    <h6>B. QUANTITY</h6>
                    <b-form-radio-group stacked v-model="frmGCIFdata.conformQtyMaterial" name="materialQty">
                        <b-form-radio :value="1">Confirm</b-form-radio>
                        <b-form-radio :value="0">Not Confirm</b-form-radio>
                    </b-form-radio-group>
                    <b-form-group :horizontal="false" label="If Unsatisfactory explain :">
                        <b-form-textarea v-model="frmGCIFdata.unconformQtyMaterialReason" rows="3" max-rows="6"></b-form-textarea>                    
                    </b-form-group>       
                    </b-card>
                </b-card-group>
                <h6 class="ml-2 mt-3">5. REASON FOR REJECTION (IF ANY AND DETAIL INCLUDING PHOTO)</h6>
                <b-card-group>
                    <b-card>
                        <b-form-textarea v-model="frmGCIFdata.reasonReject" rows="3" max-rows="6" placeholder="Reason for Rejection"></b-form-textarea>                    
                    <div slot="footer" class="text-right">
                        <b-button variant="btn btn-primary mr-1" @click="toggleShowImg()"> <i class="fa fa-file-image-o"></i> Upload Photo</b-button>
                        <b-button variant="btn btn-primary mr-1" @click="deleImage()"><i class="fa fa-trash"></i> Delete Photo
                        </b-button>
                        </div>
                    </b-card>
                    <b-card>
                    <my-upload field="gambar" :noCircle="true"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="showImgTool"
                        :width="300"
                        :height="300"
                        :url="imgUploadUrl"
                        langType="en"
                        :params="imgParams"
                        :headers="imgHeaders"
                        img-format="png"></my-upload>
                    <img :src="imgDataUrl">
                    </b-card>
                </b-card-group>
            </b-card>
        <hr>
        <b-row class="justify-content-center mb-2">
            <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
            </button>
            <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
        </b-row>
        
    </b-card>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import moment from "moment";
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import inv from "../../apis/logistic_inv_in";
import vDim from "../lookup/dim";

toastr.init();

export default {
  components: { myNumber, myUpload, vDim},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        inven_catid: { required },
        quantity: { required },
        invUnitCost: { required },
        invunitom: { required },
        qtyPurcRcp: {required : (function() {
            // if (!(this.model.purcOrderNo)){
            //     return false;
            // } else {
                return true;
            // }
        })},

        idStore : { required },
        shelfNo : { required },
        serialNum: { required:requiredIf('isexpireable') },
        expirDate: { required:requiredIf('ishasserialno') }
    },
  },
  data() {
    return {
      horizontal: true,
      showList:true,
      showForm:false,
      showGCIF:false,
      updateDim:false,
      frmdata:{ishasserialno:0, isexpireable:0,quantity: '', invunitom: '',invUnitCost:0, qtyPurcRcp:1, gcif:0, idStore:'',shelfNo:'',serialNum:'',expirDate:'', gcif:0, barangbarter:0 },
      frmGCIFdata:{unsatisConPackReason:'',unsatisPreserveReason:'',unsatisTechDocReason:'', unSatisCondMaterialReason:'', unconformQtyMaterialReason:'', reasonReject:''},
      itemCondition:{},
      conditionOpt:[
        { value: { barangbekas:0,barangrusak:0 }, text: 'Baru'},
        {value: { barangbekas:1,barangrusak:0 }, text: 'Bekas'},
        {value: { barangbekas:0,barangrusak:1 }, text: 'Rusak'},
      ],
      headCategories:[],
      uanguser: this.$store.state.user.matauang,
      showImgTool:false,
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      warehouse:[]
    };
  },
  computed: {
    isexpireable(){
        return this.frmdata.isexpireable;
    },
    ishasserialno(){
        return this.frmdata.ishasserialno;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    useGCIF(){
      return this.frmdata.gcif;
    }
  },
  watch : {
    useGCIF: function(newVal) {
        if (newVal == 0) {
          this.showGCIF= false;
        } else if (newVal == 1) {
          this.showGCIF= true;
        }
    },
    itemCondition(val){
            for (const element in val) {
                this.frmdata[element] = val[element];
            }
        },
  },
  created: async function(){
    if (this.$route.params.itemReciKey)  {
        toastr.info('Loading Request Detail, please wait')
        try {
        const [a,b,data] = await Promise.all([inv.inventorygroup(),inv.store(),inv.detailInvReceipt(this.$route.params)]) ;
        this.headCategories = a;
        this.warehouse = b;
        if (b[0]) {
            this.frmdata.idStore= b[0].value;
        }   
        const frmdata = data[0][0];
        frmdata.recivDate = frmdata.recivDate ? moment(frmdata.recivDate).format('YYYY-MM-DD') : '';
        frmdata.expirDate = frmdata.expirDate ? moment(frmdata.expirDate).format('YYYY-MM-DD') : '';
        for (var key in frmdata) {
            this.frmdata[key] = frmdata[key];
        }
        this.frmdata.nettpriceFCY=this.frmdata.invUnitCostFCY*this.frmdata.quantity;
        this.frmdata.nettprice=this.frmdata.invUnitCost*this.frmdata.quantity;
        this.updateDim=!this.updateDim;
        if(data[1].length > 0){
            // console.log('ada gcif')
            this.showGCIF = true;
            this.frmdata.gcif=1;
        }
        const frmGCIFdata  =data[1][0]

        for (var key in frmGCIFdata) {
            this.frmGCIFdata[key] = frmGCIFdata[key];
        }
        this.itemCondition={ barangbekas:this.frmdata.barangbekas,barangrusak:this.frmdata.barangrusak }
        toastr.clear;
        } catch (error) {
            console.log('error : ', error);
            toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
        }
    } else {
        const [a, b] = await Promise.all([inv.inventorygroup(), inv.store()]);
        this.headCategories = a;
        this.warehouse = b;
        if (b[0]) {
            this.frmdata.idStore= b[0].value;
        }   
    }
  },
  methods: {
    save: async function (callback) {
        if (this.invalidFormdata) {
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
        } else {
            try {
              // Note apakah perlu dibuatkan validation saat input gcif
              this.frmdata.gcifData = this.frmGCIFdata;
              this.frmdata.invValue = this.frmdata.invUnitCost * this.frmdata.quantity;
              const result = await inv.save(this.frmdata);
              this.showGCIF = false;
              this.showForm = false;
              toastr.success("Complete successfully", "Save Inventory Receipt");
              router.push({name :'logistic.inv_in'});
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },        
    close(){
        router.push({name:'logistic.inv_in'});
    },   
    toggleShowImg() {
        this.showImgTool = !this.showImgTool;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field){
        console.log('-------- crop success --------', field);
        this.imgDataUrl=imgDataUrl;
        // console.log(imgDataUrl);
        // console.log('content ',this[field]);
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field){
        console.log('-------- upload success --------');
        console.log(jsonData);
        console.log('field: ' + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field){
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
    }

  }
};
</script>
